import { ResolutionFactoCohabitationFormVM } from 'mutation/view-models/resolution-facto-cohabitation';
import { RequestAnprData } from 'shell/models/person';

export const transformerRequestResolutionFactoCohabitationData = (
  values: ResolutionFactoCohabitationFormVM
): RequestAnprData => ({
  testataRichiesta: {
    dataDecorrenza: values.editDataControl?.dateValidity?.toFormat('yyyy-MM-dd') || '',
    dataDefinizionePratica: values.editDataControl?.dateDefinitionFile || '',
    dataOraRichiesta: values.editDataControl?.datetimeRequest || '',
    dataProtocolloComune: values.editDataControl?.protocolDate || '',
    operazioneRichiesta: values.editDataControl?.operation || '5008',
    protocolloComune: values.editDataControl?.protocol || '',
    tipoOperazione: values.editDataControl?.operationType || 'R',
  },
  generalitaPerRicerca: { ...(values?.dichiarante?.generalita || {}) },
  convivenzaDiFatto: {
    convivente: values.convivente?.generalita || null,
    cittadinanza: values.cohabitant?.citizenship
      ? {
          descrizioneStato: values.cohabitant.citizenship.value,
          codiceStato: values.cohabitant.citizenship.id,
          noteStato: values.cohabitant.noteCitizenship || null,
        }
      : undefined,
    contrattoStipula: {
      data: values.cohabitant?.contractStipulation?.dateStart?.toFormat('yyyy-MM-dd'),
      protocollo: values.cohabitant?.contractStipulation?.protocol,
      dataDocumento: values.cohabitant?.contractStipulation?.dateDocument?.toFormat('yyyy-MM-dd'),
    },
    contrattoRisoluzione: {
      motivoRisoluzione: Number(values.cohabitationData?.reasonTermination) || undefined,
      contratto: {
        data: values.cohabitationData?.endCohabitationDate?.toFormat('yyyy-MM-dd') || '',
        dataDocumento:
          values.cohabitationData?.endCohabitationDate?.toFormat('yyyy-MM-dd') || undefined,
        dataNotifica:
          values.cohabitationData?.dateNotification?.toFormat('yyyy-MM-dd') || undefined,
        protocollo: values.cohabitationData?.protocol || undefined,
        comuneRegistrazione: {
          nomeComune: values.cohabitationData?.municipality?.description || '',
          codiceIstat: values.cohabitationData?.municipality?.id || '',
          siglaProvinciaIstat: values.cohabitationData?.municipality?.province || '',
        },
        professionista: values.cohabitationData?.professionist || '',
        luogoEvento:
          values.cohabitationData?.eventItaly || values.cohabitationData?.eventForeign
            ? {
                comune: values.cohabitationData?.eventItaly?.municipalityId
                  ? {
                      nomeComune:
                        values.cohabitationData.eventItaly.municipalityDescription || undefined,
                      codiceIstat: values.cohabitationData.eventItaly.municipalityId || undefined,
                      siglaProvinciaIstat: values.cohabitationData.eventItaly.province || undefined,
                    }
                  : undefined,
                localita: values.cohabitationData?.eventForeign?.stateId
                  ? {
                      descrizioneLocalita:
                        values.cohabitationData.eventForeign.municipalityDescription || undefined,
                      descrizioneStato:
                        values.cohabitationData.eventForeign.stateDescription || undefined,
                      codiceStato: values.cohabitationData.eventForeign.stateId || undefined,
                      provinciaContea: values.cohabitationData.eventForeign.province || undefined,
                    }
                  : undefined,
              }
            : undefined,
      },
    },
    ordineConvivenza: values.cohabitant?.orderCoexistence,
  },
  datiControllo: {
    gestioneCF: values.editDataControl?.flag || '',
    tipoMutazione: values.editDataControl?.mutationReason
      ? [String(values.editDataControl.mutationReason.id)]
      : [],
    listaControlli: values.editDataControl?.sendType
      ? { controllo: [{ codice: 'CL', valore: values.editDataControl.sendType }] }
      : undefined,
  },
});
